const notifications = {
  // Page title
  title: 'Notifications',
  allNotifications: 'All Notifications',

  // Header
  header: {
    title: 'Notifications',
    markAllRead: 'Mark all as read',
    viewAll: 'View all',
    noNotifications: 'No notifications',
    noNotificationsDescription: 'Your notifications will appear here',
  },

  // Notification types
  types: {
    listing_view: 'Listing View',
    listing_contact: 'New Contact',
    listing_save: 'Listing Saved',
    listing_expiry: 'Listing Expiry',
    subscription_renewal: 'Subscription Renewal',
    subscription_expiry: 'Subscription Expiry',
    license_expiry: 'License Expiry',
    new_review: 'New Review',
    lead_response: 'Lead Response',
    system: 'System Notification',
    promotion: 'Promotional',
  },

  // Common notification messages
  messages: {
    listingViewed: 'Your listing "{{title}}" was viewed',
    newContact: 'You have a new contact on "{{title}}"',
    listingSaved: 'Someone saved your listing "{{title}}"',
    listingExpiringSoon: 'Your listing "{{title}}" expires in {{days}} days',
    listingExpired: 'Your listing "{{title}}" has expired',
    subscriptionExpiringSoon: 'Your subscription expires in {{days}} days',
    subscriptionExpired: 'Your subscription has expired',
    subscriptionRenewed: 'Your subscription was renewed successfully',
    licenseExpiringSoon: 'Your license expires in {{days}} days',
    licenseExpired: 'Your license has expired',
    newReview: 'You received a new review',
    leadResponse: 'You have a response to your request',
    viewMilestone: 'Your listing "{{title}}" reached {{count}} views!',
  },

  // Actions
  actions: {
    view: 'View',
    renew: 'Renew',
    upgrade: 'Upgrade',
    respond: 'Respond',
    dismiss: 'Dismiss',
  },

  // Filters
  filters: {
    all: 'All',
    unread: 'Unread',
    listings: 'Listings',
    subscription: 'Subscription',
    reviews: 'Reviews',
    system: 'System',
  },

  // Settings
  settings: {
    title: 'Notification Settings',
    subtitle: 'Control the notifications you receive',

    // Channels
    channels: {
      title: 'Notification Channels',
      email: 'Email',
      emailDescription: 'Receive notifications via email',
      push: 'Push Notifications',
      pushDescription: 'Receive instant notifications on your device',
      sms: 'SMS',
      smsDescription: 'Receive notifications via SMS',
    },

    // Categories
    categories: {
      title: 'Notification Types',
      listings: 'Listing Notifications',
      listingsDescription: 'Views, contacts, and saves',
      subscription: 'Subscription Notifications',
      subscriptionDescription: 'Renewals, expiry, and billing',
      marketing: 'Promotional',
      marketingDescription: 'Offers, discounts, and news',
      reviews: 'Review Notifications',
      reviewsDescription: 'New reviews and replies',
    },

    // Frequency
    frequency: {
      title: 'Notification Frequency',
      realtime: 'Real-time',
      realtimeDescription: 'Receive notifications as they happen',
      daily: 'Daily Digest',
      dailyDescription: 'Receive a daily summary of notifications',
      weekly: 'Weekly Digest',
      weeklyDescription: 'Receive a weekly summary of notifications',
    },

    // Actions
    save: 'Save Settings',
    saved: 'Settings saved',
    reset: 'Reset to Default',
  },

  // Time
  time: {
    now: 'Just now',
    minutesAgo: '{{count}} minute(s) ago',
    hoursAgo: '{{count}} hour(s) ago',
    daysAgo: '{{count}} day(s) ago',
    weeksAgo: '{{count}} week(s) ago',
  },

  // Status
  status: {
    read: 'Read',
    unread: 'Unread',
  },
};

export default notifications;
